// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  officeId: __t.u64().primaryKey().name("office_id"),
  civ: __t.string(),
  office: __t.string(),
  holderId: __t.u64().name("holder_id"),
  holderName: __t.string().name("holder_name"),
  settlementId: __t.u64().name("settlement_id"),
  sinceAt: __t.timestamp().name("since_at"),
});
